import { hash } from '@ember/helper';
import { service } from '@ember/service';

import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class RecordDetailFormsSpacerComponent extends Component {
  // Services
  @service intl;

  // Defaults
  behaviours = [0, 1];

  // Getter, setter and computed properties
  get behaviourOptions() {
    return labelValueOptions.call(this, this.behaviours, [
      'forms.spacer.options.behaviour',
    ]);
  }

  // Template
  <template>
    {{#unless @mlp.isV2}}
      <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
        <div class='o-layout'>
          <div class='o-layout__item u-1/1 u-1/2@tablet'>
            <form.fieldset @titleKey='content' as |fieldset|>
              <fieldset.field @property='headline' />
              <fieldset.field @property='text' @type='text-editor' />
            </form.fieldset>
          </div>
          <div class='o-layout__item u-1/1 u-1/2@tablet'>
            <form.fieldset @titleKey='general' as |fieldset|>
              <fieldset.field
                @property='behaviour'
                @type='select-value'
                @options={{this.behaviourOptions}}
              />
              <fieldset.field
                @filters={{hash assetFolderId='8'}}
                @property='logo'
                @options={{hash allowedFolder='8'}}
                @type='belongs-to'
                as |record|
              >
                <AssetPreview @asset={{record}} />
              </fieldset.field>
            </form.fieldset>
          </div>
        </div>
      </Form>
    {{/unless}}
    {{#if @mlp.isV2}}
      <InfoBox @type='warning'>
        {{t 'record_detail.forms.spacer.not_for_mlp_v2'}}
      </InfoBox>
    {{/if}}
  </template>
}
